export default __webpack_public_path__ + "static/media/focusLogo.e2ec218e.svg";